import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(() => {
  return {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 3,
      position: "relative",
    },
    labelContainer: {
      position: "absolute",
      left: 9,
      top: -13,
      backgroundColor: "white",
      zIndex: 1000,
      paddingLeft: 5,
      paddingRight: 5,
    },
  };
});

export default useStyles;
